"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Color = require("../core/Color");

var _Functions = require("../core/Functions");

var _UIIconCircle = _interopRequireDefault(require("../icon/UIIconCircle"));

var _iconName = require("../utils/propTypes/iconName");

var _UIUnstyledButton = _interopRequireDefault(require("../button/UIUnstyledButton"));

var _FieldsetContext = require("../context/FieldsetContext");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* Extra specificity to override base UIUnstyledButton styles */\n  && {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SIZES = {
  small: 16,
  default: 20
};

var getStyle = function getStyle(size) {
  return {
    height: size * 2
  };
};

var Button = (0, _styledComponents.default)(function (props) {
  var __hasOpacity = props.hasOpacity,
      rest = (0, _objectWithoutProperties2.default)(props, ["hasOpacity"]);
  return _react.default.createElement(_UIUnstyledButton.default, rest);
}).withConfig({
  displayName: "UIColorSwatch__Button",
  componentId: "a0melx-0"
})(_templateObject(), function (_ref) {
  var hasOpacity = _ref.hasOpacity;
  return hasOpacity && "background-image: url('" + require('bender-url!ui-images/optimized/transparent_background.svg') + "');";
});

var UIColorSwatch =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIColorSwatch, _PureComponent);

  function UIColorSwatch(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIColorSwatch);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIColorSwatch).call(this, props));
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIColorSwatch, [{
    key: "handleClick",
    value: function handleClick() {
      (0, _Functions.callIfPossible)(this.props.onClick, (0, _SyntheticEvent.default)(this.props.color));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          borderColor = _this$props.borderColor,
          borderWidth = _this$props.borderWidth,
          className = _this$props.className,
          color = _this$props.color,
          iconClassName = _this$props.iconClassName,
          iconColor = _this$props.iconColor,
          iconName = _this$props.iconName,
          __onClick = _this$props.onClick,
          selected = _this$props.selected,
          size = _this$props.size,
          opacity = _this$props.opacity,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["borderColor", "borderWidth", "className", "color", "iconClassName", "iconColor", "iconName", "onClick", "selected", "size", "opacity"]);
      var hasOpacity = opacity != null;
      var backgroundColor = hasOpacity ? (0, _Color.rgba)(color, opacity / 100) : color;
      var computedColor = selected ? iconColor : 'transparent';
      return _react.default.createElement(_FieldsetContext.FieldsetContextConsumer, null, function (fieldsetContext) {
        var computedSize = size != null ? size : SIZES[fieldsetContext.size];
        return _react.default.createElement(Button, {
          className: className,
          hasOpacity: hasOpacity,
          onClick: _this2.handleClick,
          style: _this2._getStyle(computedSize)
        }, _react.default.createElement(_UIIconCircle.default, (0, _extends2.default)({}, rest, {
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: borderWidth,
          color: computedColor,
          iconClassName: iconClassName,
          legacy: true,
          name: iconName,
          size: computedSize
        })));
      });
    }
  }]);
  return UIColorSwatch;
}(_react.PureComponent);

UIColorSwatch.propTypes = {
  borderColor: _react.PropTypes.string,
  borderWidth: _react.PropTypes.number,
  color: _react.PropTypes.string,
  iconColor: _react.PropTypes.string,
  iconName: (0, _iconName.getIconNamePropType)(),
  iconClassName: _react.PropTypes.string,
  selected: _react.PropTypes.bool,
  size: _react.PropTypes.number,
  opacity: _react.PropTypes.number
};
UIColorSwatch.defaultProps = {
  borderWidth: 0,
  iconColor: _colors.OLAF,
  iconName: 'success',
  selected: false
};
UIColorSwatch.displayName = 'UIColorSwatch';
var _default = UIColorSwatch;
exports.default = _default;
module.exports = exports.default;